import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import {
  COMPENSATION_ROLES,
  isLoanOfficer,
  isLoanOfficerAssistant
} from 'app/constants/compensation';
import UserCompensations from '../../user/UserCompensations';

/**
 * What this person earns, on their own profile, in read-only form.
 *
 * There was no such tab: commission could only be seen by opening somebody's profile
 * from the Admin Console, so the people it belongs to were the only ones who could
 * not see it.
 *
 * Read-only by construction rather than by a prop that could be flipped: nothing here
 * takes an `onChange`, and the API strips `compensations`, `loanOfficerAssistants`
 * and `licence` from a self-edit regardless of what this screen sends.
 *
 * The assistant table and the Add Assistant button are deliberately not here. Both are
 * about managing other people, which is a different tab on a different screen.
 */
function FinancialsTab({ form }) {
  const earnsAsOfficer = isLoanOfficer(form);
  const earnsAsAssistant = isLoanOfficerAssistant(form);
  const compensations = form.compensations || [];

  if (!earnsAsOfficer && !earnsAsAssistant) {
    return (
      <Typography color="textSecondary">
        You don&apos;t have commission set up. Compensation is configured for Loan
        Officers and Loan Officer Assistants — an administrator sets it on your profile.
      </Typography>
    );
  }

  return (
    <>
      <Typography className="text-13 text-grey-700 mb-16">
        What you earn per closing. An administrator sets these, so they are shown here
        rather than edited.
      </Typography>

      {earnsAsOfficer && (
        <UserCompensations
          id="compensations"
          name="compensations"
          value={compensations}
          userRole={COMPENSATION_ROLES.LOAN_OFFICER}
          licence
          readOnly
          onChange={() => {}}
        />
      )}

      {earnsAsAssistant && (
        <>
          <Box mt={3}>
            <Typography variant="h6">Loan Officer Assistant Profile</Typography>
          </Box>
          <Typography variant="subtitle1">Compensation</Typography>
          <Typography className="text-13 text-grey-700 mb-8">
            {form.licence ? 'Licenced' : 'Not Licenced'}
          </Typography>
          <UserCompensations
            id="compensations"
            name="compensations"
            value={compensations}
            userRole={COMPENSATION_ROLES.LOAN_OFFICER_ASSISTANT}
            licence={Boolean(form.licence)}
            readOnly
            onChange={() => {}}
          />
        </>
      )}
    </>
  );
}

export default FinancialsTab;
